import React from 'react';
import i18n from '@i18next/i18n';
import { Feature } from '@tencent/workbench';
import Menu from '@tencent/dui/lib/components/Menu';
import BaseDrawerGridFeature from '@src/framework/workbench/common/feature/base-drawer-grid-feature';
import { config } from '@src/framework/workbench/ui/item-number/config';
import FormItemDropdown from '@src/framework/workbench/drawer/components/dropdown';
import { ITEM_NUM_ICON } from '@src/framework/workbench/drawer/image';
import { ItemNumberController } from '@src/framework/workbench/ui/item-number/item-number-controller';
import { FORM_CONFIGS_NUM } from '@framework/workbench/drawer/ui/text/paragraph/item-num/config';
import { TOOLBAR_ITEMNUMBER } from '@editor/src/img/pageIndex';
import { SOURCE_ID } from '@src/slide/application/service/bullets-and-numbering-dialog-manager/core/constant';

@Feature()
export class ItemNumFeature extends BaseDrawerGridFeature {
    id = config.id;
    config = config;

    public constructor(private readonly toolbarController: ItemNumberController) {
        super();
    }

    public getBottomSlot() {
        return (
            <Menu.Item
                style={{ padding: '9px 11px' }}
                icon={TOOLBAR_ITEMNUMBER}
                onClick={this.handleOpen}
            >
                {i18n.t('项目符号和编号')}
            </Menu.Item>
        );
    }

    public renderItemNum() {
        return (
            <FormItemDropdown
                checked={this.toolbarController.isChecked()}
                icon={ITEM_NUM_ICON}
                dropContent={this.showContent(true, true)}
                onClick={() => this.onClick(true)}
                tooltip={FORM_CONFIGS_NUM[0].tooltip}
            />
        );
    }

    private handleOpen = () => {
        this.getAppService().editableServiceLayer?.bulletsAndNumberingDialogManager
            .promise().then((bulletsAndNumberingDialogManager) => {
                bulletsAndNumberingDialogManager.showDialog(config.id, SOURCE_ID.sideBarBullet);
            });
    };
}
